import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ChatPage } from './pages/ChatPage';
import { ProjectPage } from './pages/ProjectPage';
import { ProjectListPage } from './pages/ProjectListPage';
import { FilesPage } from './pages/FilesPage';
import { IngestPage } from './pages/IngestPage';
import { WorkbenchPage } from './pages/WorkbenchPage';
import { CompletenessPage } from './pages/CompletenessPage';
import { SentencingPage } from './pages/SentencingPage';
import { RedactionPage } from './pages/RedactionPage';
import { ThemeProvider } from './components/ThemeContext';
export function App() {
  return <ThemeProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <div className="h-full w-full" data-id="element-2">
          <Routes data-id="element-3">
            <Route path="/" element={<Navigate to="/cases" replace data-id="element-5" />} data-id="element-4" />
            <Route path="/cases" element={<ProjectListPage data-id="element-7" />} data-id="element-6" />
            <Route path="/chat" element={<ChatPage data-id="element-9" />} data-id="element-8" />
            <Route path="/case" element={<ProjectPage data-id="element-11" />} data-id="element-10" />
            <Route path="/case/ingest" element={<IngestPage data-id="element-13" />} data-id="element-12" />
            <Route path="/case/files" element={<FilesPage data-id="element-15" />} data-id="element-14" />
            <Route path="/case/files/workbench" element={<WorkbenchPage data-id="element-17" />} data-id="element-16" />
            <Route path="/case/files/redact" element={<RedactionPage data-id="element-19" />} data-id="element-18" />
            <Route path="/case/completeness" element={<CompletenessPage data-id="element-21" />} data-id="element-20" />
            <Route path="/case/sentencing" element={<SentencingPage data-id="element-23" />} data-id="element-22" />
          </Routes>
        </div>
      </BrowserRouter>
    </ThemeProvider>;
}